import React, { useMemo } from 'react';
import { StyledTimePicker, StyledTimePickerWrapper } from './DateTimeRangePicker.styled';

type TimePicker2Props = {
  value: string;
  onChange: (value: string) => void;
};

type ITime = {
  hour: number;
  minute: number;
};

const getTime = (value: string): ITime => {
  if (!value) return { hour: 0, minute: 0 };
  return {
    hour: Number(value.split(':')[0]),
    minute: Number(value.split(':')[1]),
  };
};

const getValidatedValue = (val: string, max: number, min: number): number => {
  const validated = Number(val?.match(/[0-9]/g)?.join('')) || 0;
  return Math.max(min, Math.min(max, validated));
};

const getStringValue = (val: number) => val < 10 ? `0${val}` : val;

const TimePicker = ({ value, onChange }: TimePicker2Props) => {
  const time: ITime = useMemo(() => getTime(value), [value]);

  const handleHourChange = (val: string) => {
    onChange(`${getStringValue(getValidatedValue(val, 12, 0))}:${getStringValue(time.minute)}`);
  };

  const handleMinuteChange = (val: string) => {
    onChange(`${getStringValue(time.hour)}:${getStringValue(getValidatedValue(val, 59, 0))}`);
  };

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => event.target.select();

  const handleKeyChangeHour = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === 'ArrowUp') handleHourChange(`${time.hour + 1}`);
    if (event.key === 'ArrowDown') handleHourChange(`${time.hour - 1}`);
  };

  const handleKeyChangeMinute = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === 'ArrowUp') handleMinuteChange(`${time.minute + 1}`);
    if (event.key === 'ArrowDown') handleMinuteChange(`${time.minute - 1}`);
  };

  return (
    <StyledTimePickerWrapper>
      <StyledTimePicker
        type="text"
        value={getStringValue(time.hour)}
        onFocus={handleFocus}
        onKeyUp={handleKeyChangeHour}
        onChange={(e) => handleHourChange(e.target.value)}
        placeholder="HH"
      />
      <span>:</span>
      <StyledTimePicker
        type="text"
        value={getStringValue(time.minute)}
        onKeyUp={handleKeyChangeMinute}
        onFocus={handleFocus}
        onChange={(e) => handleMinuteChange(e.target.value)}
        placeholder="MM"
      />
    </StyledTimePickerWrapper>
  );
};

export default TimePicker;
